import {z} from 'zod';

import {FinancialProductMoneySchema} from './FinancialProductMoneySchema';
import {LeasingMonthlyServiceKindSchema} from './LeasingMonthlyServiceKindSchema';
import {LeasingOneTimeItemKindSchema} from './LeasingOneTimeItemKindSchema';

/**
 * What a leasing offer costs besides its rate, exactly as the backend publishes it. Amounts are
 * as entered (no VAT conversion) and in the currency of the rates. `monthlyServicesTotal` is the
 * sum of `monthlyServices` ("0.00" when there are none). A one-time item is either included in the
 * monthly payment or paid once on top, and is published only with an amount. `leasingCosts` ships
 * in the same backend change that made the amount required (teas/backend-monorepo!15414), so no
 * released backend and no stored contract snapshot carries a null amount; an older backend omits
 * `leasingCosts` altogether.
 */
export const LeasingCostsSchema = z.object({
  monthlyServices: z.array(
    z.object({
      kind: LeasingMonthlyServiceKindSchema,
      amount: FinancialProductMoneySchema,
    })
  ),
  monthlyServicesTotal: FinancialProductMoneySchema,
  excessMileageCost: FinancialProductMoneySchema.nullable(),
  underMileageCredit: FinancialProductMoneySchema.nullable(),
  liabilityInsuranceDeductible: FinancialProductMoneySchema.nullable(),
  comprehensiveInsuranceDeductible: FinancialProductMoneySchema.nullable(),
  oneTimeItems: z.array(
    z.object({
      kind: LeasingOneTimeItemKindSchema,
      amount: FinancialProductMoneySchema,
      included: z.boolean(),
    })
  ),
});
export type LeasingCosts = z.infer<typeof LeasingCostsSchema>;
